<script setup lang="ts">
    import { toRefs } from "vue";

    const props = withDefaults(
        defineProps<{
            variant?: "default";
        }>(),
        {
            variant: "default",
        }
    );

    const { variant } = toRefs(props);
</script>

<template>
    <div class="card-view" :class="[`variant-${variant}`]">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>
    @import "@/style/variables";

    .card-view {
        max-width: $form-width;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
    }
</style>
